import { Navigate } from '@sorare/routing';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_HOME,
  ANY_SPORT_SERIES_ONBOARDING,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const LegacySeriesOnboardingPage = () => {
  const { sport, generateSportContextPath } = useSportContext();
  if (sport === Sport.BASEBALL) {
    return <Navigate to={generateSportContextPath(ANY_SPORT_HOME)} replace />;
  }
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_SERIES_ONBOARDING)}
      keepSearchParams
      replace
    />
  );
};

export default LegacySeriesOnboardingPage;
